import React, { useEffect, useState } from "react";
import userProfile1 from "../../assets/images/userProfile1.png";
import DashboardHeader from "../dashboard/DashboardHeader/DashboardHeader";
import UserProfileNav from "./UserProfileNav";
import { MdEdit } from "react-icons/md";
import { FiEye } from "react-icons/fi";
import CustomSvg from "../svgs/CustomSvg";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../utils/hooks";
import { patchRequest } from "../apiRequests/requestApi";

export default function EditProfile() {
  const navigate = useNavigate();
  const navigateTo = (path) => navigate(path);

  const goToSelectAvatar = () => navigateTo(`/user-profile/select-avatar`);

  const [passwordVisible, setPasswordVisible] = useState(false);
  const [isEditting, setIsEditting] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const togglePasswordVisibility = () => setPasswordVisible((prev) => !prev);
  const toggleEditMode = () => setIsEditting((prev) => !prev);

  const { user, setUserDetails } = useUser();

  const { bgClass, username, avatar, country, email, bio, phoneNumber, dob } =
    user;

  const [phonenum, setPhoneNumber] = useState(phoneNumber);
  const [userName, setUserName] = useState(username);
  const [biography, setBio] = useState(bio);
  const [date, setDob] = useState(dob);
  const [changedInputs, setChangedInputs] = useState({});

  const handleChange = (e, set) => {
    const { name, value } = e.target;

    set(value);

    setChangedInputs((prevChanges) => ({
      ...prevChanges,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (userName == null) {
      setUserName(username);
      setPhoneNumber(phoneNumber);
      setBio(bio);
      setDob(dob);
    }
  }, [user]);

  const update = async () => {
    try {
      setIsSaving(true);
      const response = await patchRequest({
        url: "/auth/profile",
        detail: changedInputs,
      });

      const userDetails = {
        ...user,
        ...changedInputs,
      };
      alert(response?.message);
      setUserDetails(userDetails);
      setIsEditting(false);
      setTimeout(() => {
        window.location.reload();
      }, 300); // Delay to ensure state updates before reload
    } catch (error) {
      console.error(error);
      alert("Failed to update profile. Please try again.");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="py-2 md:py-5 md:my-3 lg:py-5 lg:my-3 my-0">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-3 md:mb-5">
        <div className="flex flex-col md:flex-row md:items-center mb-4 md:mb-0 pb-3 md:pb-0">
          <div className="mx-auto md:mx-0">
            <div className="rounded-full flex items-center justify-center p-1 w-[100px] h-[100px] overflow-hidden">
              <img
                src={avatar ?? userProfile1}
                alt="Avatar"
                className="w-full h-full object-cover rounded-full"
              />
            </div>
            <div className="flex justify-center">
              <label className="p-1 rounded-full bg-white cursor-pointer">
                <input
                  type="file"
                  accept="image/*"
                  className="hidden"
                  onChange={async (e) => {
                    const file = e.target.files[0];
                    if (file) {
                      try {
                        const formData = new FormData();
                        formData.append("avatar", file);
                        const response = await patchRequest({
                          url: "/auth/profile",
                          detail: formData,
                        });
                        alert(
                          response?.message ||
                            "Profile picture updated successfully"
                        );
                      } catch (error) {
                        console.error(error);
                        alert(
                          "Failed to update profile picture. Please try again."
                        );
                      }
                    }
                  }}
                />
                <MdEdit size={15} color="#BD3193" />
              </label>
            </div>
          </div>
          <div className="mx-2 mt-3 text-center md:text-left">
            <h5 className="text-white text-base font-semibold capitalize">
              {username || "not set"}
            </h5>
            <p className="text-white/70 text-sm font-light">
              {country ?? "Country not assigned yet"}
            </p>
          </div>
        </div>
        <div
          onClick={toggleEditMode}
          className="flex items-center justify-end md:justify-center cursor-pointer"
        >
          <p className="text-sm font-normal text-[#BD3193] capitalize">
            {isEditting ? "revert" : "edit profile"}
          </p>
          <div className="mx-2">
            <CustomSvg name="arrow-right" color="#BD3193" />
          </div>
        </div>
      </div>

      <div className="flex flex-wrap justify-center md:justify-between items-start mb-4">
        <div className="w-full md:w-[48%] mb-4">
          {/* Username */}
          <div className="mb-4">
            <label className="block mb-2 text-white">Username:</label>
            <div className="flex items-center p-2 bg-gray-800 rounded">
              <input
                defaultValue={userName}
                name="username"
                disabled
                className="w-full bg-transparent text-white outline-none px-2 font-mono"
              />
            </div>
          </div>

          {/* Email */}
          <div className="mb-4">
            <label className="block mb-2 text-white">Email:</label>
            <div className="flex items-center p-2 bg-gray-800 rounded">
              <input
                type="email"
                defaultValue={email}
                disabled
                className="w-full bg-transparent text-white outline-none px-2 font-mono"
              />
            </div>
          </div>
        </div>

        <div className="w-full md:w-[48%] mb-4">
          {/* Bio */}
          <div className="mb-4">
            <label className="block mb-2 text-white">Bio:</label>
            <div className="flex items-center p-2 bg-gray-800 rounded">
              <textarea
                defaultValue={username ? biography || "Not set" : "Not Signed in"}
                name="bio"
                disabled={!isEditting}
                onChange={(e) => handleChange(e, setBio)}
                className="w-full h-[10vh] bg-transparent text-white outline-none p-2 font-mono resize-none"
              />
            </div>
          </div>
        </div>
      </div>

      {isEditting && (
        <button
          className="w-full bg-[#BD3193] flex items-center justify-center p-2 mb-5 text-white rounded"
          onClick={update}
          disabled={isSaving}
        >
          {isSaving ? (
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 border-2 border-t-transparent border-white rounded-full animate-spin" />
              <p className="text-sm font-medium">Saving...</p>
            </div>
          ) : (
            <>
              <p className="text-sm font-medium mx-1">Save</p>
              <div className="mx-2 flex items-center">
                <CustomSvg name={"arrow-right"} />
              </div>
            </>
          )}
        </button>
      )}
    </div>
  );
}
